import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import auth from '@/libs/auth'
import session from '@/libs/session'

import APIError from './errorv2'

Vue.prototype.$http = axios

let maintenanceMode = false
const setMaintenanceMode = (enable) => {
  maintenanceMode = enable
  session.set('maintenanceMode', maintenanceMode)
}

Vue.prototype._setMaintenanceMode = setMaintenanceMode

const authHeader = 'Authorization'
const sessionHeader = 'X-Session-ID'

const partner = 'X-Event'

var apiRoot = process.env.API_ROOT.replace('api', 'api-v2')

export const APIv2 = axios.create({ baseURL: apiRoot })

export const arrayQueryParamsSerializer = function (params) {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}

const addToken = (config) => {
  const token = auth.getToken()
  if (token && token !== '') {
    config.headers[authHeader] = `Bearer ${token}`

    if (token === null) {
      const id = auth.getSessionToken()
      if (id) {
        config.headers[sessionHeader] = id
      }
    }
  }
}

const addExtraHeaders = (config) => {
  config.headers[partner] = process.env.APP_NAME.toLowerCase()
}

// Add auth token to requests
APIv2.interceptors.request.use((config) => {
  if (maintenanceMode === true) {
    throw new Error('System is down for maintenance')
  }

  addToken(config)
  addExtraHeaders(config)
  return config
})

// Retry permission denied requests after refreshing the auth token
APIv2.interceptors.response.use((response) => {
  return response
}, (error) => {
  const apiError = new APIError(error)

  if (apiError.status === 401) {
    // did the request fire before we had token?
    if (error.config.headers[authHeader] === 'Bearer null' && auth.getToken()) {
      addToken(error.config)
      return axios(error.config)
    }

    return auth.checkRefreshToken().then(() => {
      addToken(error.config)
      return axios(error.config)
    }, () => {
      return Promise.reject(apiError)
    })
  }

  if (apiError.status === 503) {
    setMaintenanceMode(true)
  }

  return Promise.reject(apiError)
})
